// extracted by mini-css-extract-plugin
module.exports = {"module":"styles_module__1QMjV","rightBox":"styles_rightBox__E1oHz","logo":"styles_logo__2Uahn","substrate":"styles_substrate__35fVs"};